import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isOnboardingCandidate } from '../../utils/authRouting';

const ProtectedRoute = ({ children, allowedRoles = [], allowCandidate = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Candidates share the employee role but must stay in the onboarding portal
  const candidate = isOnboardingCandidate(user);
  if (candidate && !allowCandidate) {
    return <Navigate to="/candidate" />;
  }
  if (!candidate && allowCandidate) {
    return <Navigate to="/" />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
